import React, { Component } from 'react'
import clsx from 'clsx';

export default class Popup extends Component {

  render() {
    const { open, onClose, renderActionButtons } = this.props;
    const classes = clsx(['popup view-booking-popup', open ? 'popup_visible' : undefined]);
    return (

      <div className={classes}>
        <div className="tbl">
          <div className="tcl">
            <div className="popup__window">
              <button type="button" className="popup__close material-icons js-popup-closer" onClick={onClose}>
                close
              </button>
              <div className={`view-booking-container`}>
                <div className="card booking-info">
                  {this.props.children}
                </div>
                <div className="card booking-user-data">
                  <div className="data"></div>
                  <div className="actions">
                    {typeof renderActionButtons === 'function' && renderActionButtons()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
